import { observer } from 'mobx-react-lite';
import { useTranslation } from '@pascal/pascal-core';
import { gameStore } from '../../module/store/gameStore';

export const Timer = observer((props) => {
  const t = useTranslation()
  const { time } = gameStore

  return(
          <div className='m-g-b-timer-block'>
            <div className='m-g-b-timer-count-bg'>
              <p className='m-g-b-timer-count'>{time}</p>
            </div>
            <p className='m-g-b-timer-text'>sec</p>
          </div>
  )
});

